import { render, staticRenderFns } from "./ReviewsEmpty.vue?vue&type=template&id=0c9c4aa4&scoped=true&"
import script from "./ReviewsEmpty.vue?vue&type=script&lang=ts&setup=true&"
export * from "./ReviewsEmpty.vue?vue&type=script&lang=ts&setup=true&"
import style0 from "./ReviewsEmpty.vue?vue&type=style&index=0&id=0c9c4aa4&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c9c4aa4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/prodoctorov/pd-ssr/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0c9c4aa4')) {
      api.createRecord('0c9c4aa4', component.options)
    } else {
      api.reload('0c9c4aa4', component.options)
    }
    module.hot.accept("./ReviewsEmpty.vue?vue&type=template&id=0c9c4aa4&scoped=true&", function () {
      api.rerender('0c9c4aa4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/pages/[town-translit]/lpu/[lpu-translit]/_components/LpuReviews/components/ReviewsEmpty.vue"
export default component.exports